import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "@reduxjs/toolkit";

import { setSessionExpired } from "../slices/authSlice";

import auth from '../slices/authSlice';
import send from '../slices/sendSlice';
import updates from '../slices/updatesSlice';
import validation from '../slices/validateSlice';
import user from '../slices/userSlice';
import drawer from '../slices/drawerSlice';
import vehiclesFilters from "../slices/getVehiclesFilters";
import modal from '../slices/modalSlice';
import vehiclesEditFields from "../slices/getVehiclesEditFields";
import alert from '../slices/alertSlice';
import vehiclesUpload from "../slices/vehiclesUploadSlice";
import reports from '../slices/reportSlice';
import aiReport from "../slices/aiReportSlice";
import exportVehicles from "../slices/exportVehiclesSlice";
import departures from '../slices/departuresSlice';
import details from '../slices/detailsSlice';
import vehiclesDetails from "../slices/vehiclesDetailsSlice";
import quantity from '../slices/quantitySlice';
import statistic from '../slices/statisticSlice';
import transportStatistic from "../slices/transportStatistic";
import exportData from '../slices/exportSlice';
import vehicles from "../slices/vehiclesSlice";
import filters from '../slices/filterSlice';
import vehiclesFields from "../slices/vehiclesCreateSlice";
import form from '../slices/formSlice';
import sendForm from '../slices/sendFormSlice';
import filterList from '../slices/getFiltersSlice';
import deleteVehicle from '../slices/deleteVehicleClice';
import filterOptions from '../slices/filterOptionsSlice';
import fieldsList from '../slices/getFieldsSlice';
import fieldOptions from '../slices/fieldOptionsSlice';
import fieldUpdateList from '../slices/getFieldUpdatesSlice';
import preventive from '../slices/preventiveSlice';
import surveyFields from '../slices/getSurveyFields';
import violations from '../slices/violationsSlice';
import violationsFields from '../slices/getViolationsFields';
import violationsDetails from '../slices/violationsDetailsSlice';
import preventiveDetails from '../slices/preventiveDetails';
import preventiveFilters from '../slices/getPreventiveFilters';
import exportPreventive from '../slices/exportPreventiveSlice';
import preventivePdf from '../slices/preventivePdfSlice';

const tokenExpirationMiddleware = (store) => (next) => (action) => {

    if (action.meta && action.meta.rejectedWithValue) {
        if (action.payload === 401) {
            store.dispatch(setSessionExpired());
        }
    }
    return next(action);
};

const appReducer = combineReducers({
    auth,
    send,
    drawer,
    updates,
    user,
    validation,
    alert,
    reports,
    vehiclesDetails,
    modal,
    departures,
    vehiclesEditFields,
    details,
    deleteVehicle,
    vehiclesUpload,
    quantity,
    vehiclesFields,
    statistic,
    transportStatistic,
    exportData,
    filters,
    exportVehicles,
    aiReport,
    form,
    vehiclesFilters,
    sendForm,
    filterList,
    vehicles,
    filterOptions,
    fieldsList,
    fieldOptions,
    fieldUpdateList,
    preventive,
    surveyFields,
    violations,
    violationsFields,
    violationsDetails,
    preventiveDetails,
    preventiveFilters,
    exportPreventive,
    preventivePdf
});

const rootReducer = (state, action) => {
    if (action.type === 'auth/logoutUser/fulfilled') {
        state = undefined;
    }
    return appReducer(state, action);
};

const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(tokenExpirationMiddleware),
    devTools: {
        logOnly: false
    },
});

export default store;